import { commitEdit, type CommitEditCtx } from '../commitEdit';

/**
 * Reorder a SELECT item from `fromIndex` to `toIndex` (arrayMove semantics).
 * Commits a single `move-select-item` structural edit — a byte-splice that
 * moves the item's exact source text and preserves every untouched inter-item
 * separator/comment verbatim (see applyStructuralEdit.move.ts).
 *
 * No-op when indices are non-integer, negative, or equal — the resolver
 * planner guards too, but short-circuiting avoids an empty commit round-trip.
 */
export async function reorderColumns(
  fromIndex: number,
  toIndex: number,
  ctx: CommitEditCtx,
): Promise<void> {
  if (
    !Number.isInteger(fromIndex) ||
    !Number.isInteger(toIndex) ||
    fromIndex < 0 ||
    toIndex < 0 ||
    fromIndex === toIndex
  ) {
    return;
  }
  await commitEdit({ op: 'move-select-item', fromIndex, toIndex }, ctx);
}
